import Vue from 'vue'
// @ts-ignore
import order_search  from "../components/ProductSearch";
import order_list from "components/OrderList.vue";
document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector("#product-search");
    const scopeElement = document.getElementById('disclosure-scope')
    const scope = scopeElement.dataset.scope
    const app = new Vue({
        render: h => h(order_search, {
            props: {
                queryKeyword: el.getAttribute('data-query-keyword'),
                queryCategoryId: el.getAttribute('data-query-category-id'),
                queryMaker: el.getAttribute('data-query-maker'),
                queryBrand: el.getAttribute('data-query-brand'),
                scope: scope
            }
        }),
    }).$mount();
    el.appendChild(app.$el);
});
